import { Component } from 'react'
import { connect } from 'react-redux'
import {
  OVERVIEW_ALL_FETCH_REQUESTED,
  OVERVIEW_ALL_OFFICE_FETCH_REQUESTED,
  OVERVIEW_ALL_USER_FETCH_REQUESTED
} from 'components/Dashboard/actions'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import s from './OverviewNewModal.scss'
import { timezoneDate } from 'utils/helpers'
import { APP_CONSTANTS } from 'utils/constants'
import { getCurrency } from 'utils/authService'

@connect(({ dashboard }) => {
  return {
    dashboard
  }
})
class OverviewNewModalContainer extends Component {
  componentDidUpdate = prevProps => {
    if (
      this.props.showOverviewNewModal !== prevProps.showOverviewNewModal &&
      this.props.showOverviewNewModal === true &&
      !this.props.propData
    ) {
      this.getOverviewAll()
    }
  }

  getOverviewAll = () => {
    const { officeId, userId, isAdmin, stage } = this.props

    if (isAdmin) {
      if (officeId === 'allOffices' && userId === 'allUsers') {
        this.props.dispatch({
          type: OVERVIEW_ALL_FETCH_REQUESTED,
          payload: { stage }
        })
      } else if (userId === 'allUsers') {
        this.props.dispatch({
          type: OVERVIEW_ALL_OFFICE_FETCH_REQUESTED,
          payload: { officeId, stage }
        })
      } else {
        this.props.dispatch({
          type: OVERVIEW_ALL_USER_FETCH_REQUESTED,
          payload: { userId, stage }
        })
      }
    } else {
      this.props.dispatch({
        type: OVERVIEW_ALL_USER_FETCH_REQUESTED,
        payload: { userId, stage }
      })
    }
  }

  redirectDealId = (dealId, isProposal) => {
    if (isProposal) {
      window.open(window.location.origin + '/proposals/' + dealId)
    } else {
      window.open(window.location.origin + '/opportunities/' + dealId)
    }
  }

  render() {
    const { showOverviewNewModal, title, propData, isProposal, tableHeaderStyle } = this.props
    const { overviewAll } = this.props.dashboard
    const data = propData || overviewAll.deals || []
    data.sort((a, b) => new Date(a.dueDate) - new Date(b.dueDate))
    const { symbol } = getCurrency()

    return (
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={showOverviewNewModal}
        toggle={this.toggleOverviewNewModal}
        size="lg"
      >
        <ModalHeader className={s.modalHeader}>{title}</ModalHeader>
        <ModalBody className={s.modalBody}>
          <div className={s.tableWrapper}>
            <table>
              <thead style={tableHeaderStyle} className={s.tableHeader}>
                <tr>
                  <th>Name</th>
                  <th>Due Date</th>
                  <th>Status</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                {data.map(el => (
                  <tr key={el.id}>
                    <td
                      onClick={() => this.redirectDealId(el.id, isProposal)}
                      className={s.dealName}
                    >
                      {el.name}
                    </td>
                    <td>{timezoneDate(el.dueDate)}</td>
                    <td>
                      {el.status &&
                        (isProposal ? APP_CONSTANTS.ProposalStatus[el.status] : el.status?.name)}
                    </td>
                    <td>
                      <strong>
                        {el.value ? `${symbol}${el.value.toLocaleString()}` : `${symbol}0`}
                      </strong>
                    </td>
                  </tr>
                ))}
                {data.length === 0 && (
                  <tr>
                    <td>There are no opportunities</td>
                    <td />
                    <td />
                    <td />
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.props.onClick}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default OverviewNewModalContainer
